<template>
    <div>
        <Row :gutter="20">
            <Col span="12">
                <FormItem prop="planDate" label="应收款日">
                    <DatePicker
                        v-model="info.planDate"
                        style="width: 100%"
                        type="date"
                        placeholder
                    />
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem label="单位名称" prop="comName">
                    <Input
                        v-model="info.comName"
                        :maxlength="100"
                        :disabled="!isView"
                    ></Input>
                </FormItem>
            </Col>
        </Row>
        <!-- 新增账单 -->
        <Row :gutter="20" v-if="isAdd">
            <Col span="7">
                <FormItem prop="feeType" label="其它费用">
                    <Select
                        v-model="info.feeType"
                        transfer
                        :placeholder="isView ? '' : '请选择费用类型'"
                        style="width: 210px; display: inline-block"
                    >
                        <Option
                            v-for="item in dict.otherFee.toList()"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.text }}</Option
                        >
                    </Select>
                </FormItem>
            </Col>
            <Col span="10">
                <FormItem prop="planAmount">
                    <input-number v-model="info.planAmount" placeholder>
                        <span slot="append">元</span>
                    </input-number>
                </FormItem>
            </Col>
        </Row>
        <!-- 详情及修改 -->
        <Row :gutter="20" v-else>
            <Col span="12">
                <FormItem prop="feeType" label="费用类型">
                    <Select
                        v-model="info.feeType"
                        transfer
                        placeholder
                        style="width: 210px; display: inline-block"
                        :disabled="!isView"
                    >
                        <Option
                            v-for="item in dict.feeType.toList()"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.text }}</Option
                        >
                    </Select>
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem label="应收金额" prop="planAmount">
                    <span v-if="isView" style="padding-left: 9px">
                        {{ info.planAmount | currency }} 元
                        <span style="color: red">{{ resAmountText }}</span>
                    </span>
                    <input-number
                        v-else
                        v-model="info.planAmount"
                        placeholder
                        :disabled="info.feeType === '2'"
                    >
                        <span slot="append">元</span>
                    </input-number>
                    <!-- 定金备注-只在非详情显示 -->
                    <span class="res-amount-text" v-if="!isView">
                        {{ resAmountText }}
                    </span>
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem label="租客提交时间" prop="submitTime">
                    {{ (info.submitTime || '') | ymdL }}
                </FormItem>
            </Col>
        </Row>
    </div>
</template>

<script>
import { getResAmountText } from '@/views/common/u-contract'
export default {
    props: {
        info: {
            type: Object,
            default: () => ({}),
        },
        dict: {
            type: Object,
            default: () => ({}),
        },
        isAdd: {
            type: Boolean,
            default: false,
        },
        isView: {
            type: Boolean,
            default: false,
        },
        depositOffset: {
            type: [String, Number],
            default: '',
        },
        offsetAmount: {
            type: [String, Number],
            default: '',
        },
    },
    computed: {
        resAmountText() {
            return getResAmountText(
                {
                    depositOffset: this.depositOffset,
                    offsetAmount: this.offsetAmount,
                },
                false
            )
        },
    },
}
</script>
<style lang="less" scoped>
.res-amount-text {
    color: red;
    position: absolute;
    top: 27px;
    left: 0px;
}
</style>
